module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "templates",
    attrs: {
      "id": "templates-index"
    }
  }, [_c('div', {
    staticClass: "header-with-action"
  }, [_c('h1', {
    staticClass: "pull-left"
  }, [_vm._v(_vm._s(_vm.$t('template.title.index')))]), (_vm.current_user.can_manage_templates) ? _c('router-link', {
    staticClass: "btn btn-primary pull-right",
    attrs: {
      "to": "/templates/criar"
    }
  }, [_c('div', {
    staticClass: "icon-more"
  }, [_vm._v("+")]), _vm._v(_vm._s(_vm.$t('template.actions.new')))]) : _vm._e(), _c('div', {
    staticClass: "clear"
  })], 1), _c('list')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-04c687a0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/index.vue
// module id = 1003
// module chunks = 1